import { apiSlice } from "../../apiSlice";

const headers = { Modulecima: "dashboax" };

export const opepanelApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getOpePanelData: builder.query({
      query: () => ({
        url: `/Dashboax/Graphics/OpePanel`,
        method: "GET",
        headers,
      }),
    }),
  }),
});

export const { useGetOpePanelDataQuery } = opepanelApiSlice;
